import React, { useContext } from "react"
import { Navigate } from "react-router-dom"
import { pagesUrl } from "@app/core/appConstants"
import { OrganizationContext } from "@app/core/context/organization/OrganizationContext"

type IProps = {
  children: React.JSX.Element | null
}

/**
 * US 2566 — the Macro Maker page opened by a member of an organization without the Macro Maker option (a bookmark, a
 * shared link) goes back home. Only once the organization is known.
 */
export default function RequireMacroMakerOption({ children }: IProps): React.JSX.Element | null {
  const { organization } = useContext(OrganizationContext)
  if (organization && !organization.macroMakerOption) {
    return <Navigate to={pagesUrl.HOME} replace />
  }
  return children
}
